import React from "react";
import { T } from "../theme";
import { Btn, Card } from "../ui";

export default function LimitNoticeCard({ message, onUpgrade, onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(23,20,17,0.5)", zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <Card style={{ maxWidth: 340, width: "100%", textAlign: "center", padding: 24 }}>
        <div style={{ fontSize: 28, marginBottom: 10 }}>🔒</div>
        <div style={{ fontSize: 14, color: T.text, lineHeight: 1.6, marginBottom: 18 }}>{message}</div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="outline" onClick={onClose} style={{ flex: 1 }}>Not Now</Btn>
          <Btn variant="gold" onClick={onUpgrade} style={{ flex: 1 }}>Upgrade</Btn>
        </div>
      </Card>
    </div>
  );
}
